/**
 * Size Guide Toggle Action
 * Triggered by: arc:action:sizeGuideToggle
 *
 * Dispatches a 'size-guide:toggle' window event which the sizeGuideDrawer
 * Alpine component listens for to open/close the size guide drawer.
 *
 * Usage (button-link custom_actions field):
 *   sizeGuideToggle
 */

export const runSizeGuideToggle = async (data = {}) => {
  try {
    window.dispatchEvent(new CustomEvent('size-guide:toggle', { detail: data }));

    return {
      success: true,
      message: 'Size guide toggled successfully',
    };
  } catch (error) {
    console.error('Error toggling size guide:', error);
    return {
      success: false,
      error: error.message,
    };
  }
};

export default runSizeGuideToggle;
